enum BatchTypes {
	EDIT_RECORDS,
	RUN_WORKFLOW,
	DOWNLOAD_MEDIA,
	COLLECTION_SHARE,
	REMOVE_MEDIA
}